module.exports = "<div class=\"divLoading {{position}}\" [ngClass]=\"{'show' : showLoading}\">\r\n    <div class=\"spinner-wrap\">\r\n        <i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./SignClient/app/shared/controls/loading.control.html
// module id = ./SignClient/app/shared/controls/loading.control.html
// module chunks = main